import { Injectable } from '@angular/core';
import { createAction, props, Store } from '@ngrx/store';
import { SystemSettings } from './system-settings.state';

@Injectable({
    providedIn: 'root' // No need to provide in AppModule, and now tree shakable
})
export class SystemSettingsActions {
    static getSystemSettings = createAction('[Dashboard] Get System Settings');
    static getSystemSettingsSuccess = createAction('[Dashboard] Get System Settings Success', props<SystemSettings>());
}
